import React from 'react';
import { BaseBadge } from './Badge.styles.js';

function Badge(_a) {
  var _b = _a.color,
      color = _b === void 0 ? 'black' : _b,
      _c = _a.background,
      background = _c === void 0 ? 'white' : _c,
      _d = _a.height,
      height = _d === void 0 ? '30px' : _d,
      _e = _a.width,
      width = _e === void 0 ? '30px' : _e,
      borderColor = _a.borderColor,
      children = _a.children;
  return React.createElement(BaseBadge, {
    color: color || 'black',
    background: background || 'white',
    height: height,
    width: width,
    borderColor: borderColor || 'none'
  }, children);
}

export { Badge };